export interface CategoryItem {
  key: string;
  label: string;
  url: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    key: 'shoes',
    label: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20white%20and%20pastel%20sneaker%20pair%20displayed%20on%20a%20clean%20minimal%20light%20beige%20studio%20background%20with%20soft%20natural%20lighting%20editorial%20product%20photography%20crisp%20detail%20gentle%20shadows%20premium%20ecommerce%20aesthetic&width=400&height=400&seq=cat-shoes-01&orientation=squarish',
  },
  {
    key: 'hoodies',
    label: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20in%20soft%20neutral%20tone%20neatly%20displayed%20on%20a%20clean%20white%20minimal%20background%20soft%20diffused%20lighting%20editorial%20product%20photography%20high%20detail%20fabric%20texture%20modern%20streetwear%20ecommerce%20aesthetic&width=400&height=400&seq=cat-hoodies-01&orientation=squarish',
  },
  {
    key: 'tshirts',
    label: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Plain%20premium%20cotton%20t-shirt%20in%20soft%20pastel%20color%20folded%20on%20a%20clean%20light%20background%20minimal%20studio%20setup%20soft%20natural%20light%20editorial%20product%20photography%20crisp%20fabric%20detail%20modern%20apparel%20aesthetic&width=400&height=400&seq=cat-tshirts-01&orientation=squarish',
  },
  {
    key: 'jackets',
    label: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Trendy%20lightweight%20jacket%20in%20neutral%20earth%20tone%20on%20a%20clean%20minimal%20light%20background%20soft%20studio%20lighting%20editorial%20product%20photography%20detailed%20stitching%20texture%20contemporary%20fashion%20ecommerce%20aesthetic&width=400&height=400&seq=cat-jackets-01&orientation=squarish',
  },
  {
    key: 'pants',
    label: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Casual%20jogger%20pants%20in%20soft%20muted%20color%20laid%20flat%20on%20clean%20white%20background%20minimal%20studio%20lighting%20editorial%20product%20photography%20crisp%20fabric%20detail%20modern%20streetwear%20aesthetic&width=400&height=400&seq=cat-pants-01&orientation=squarish',
  },
  {
    key: 'headwear',
    label: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20in%20neutral%20color%20on%20a%20clean%20minimal%20light%20background%20soft%20diffused%20studio%20lighting%20editorial%20product%20photography%20crisp%20embroidery%20detail%20modern%20streetwear%20aesthetic&width=400&height=400&seq=cat-headwear-01&orientation=squarish',
  },
  {
    key: 'sets',
    label: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20two%20piece%20outfit%20set%20displayed%20on%20a%20clean%20light%20background%20minimal%20studio%20styling%20soft%20natural%20light%20editorial%20product%20photography%20modern%20fashion%20ecommerce%20aesthetic&width=400&height=400&seq=cat-sets-01&orientation=squarish',
  },
  {
    key: 'underwear',
    label: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Soft%20comfortable%20cotton%20underwear%20folded%20neatly%20on%20clean%20white%20background%20minimal%20studio%20lighting%20editorial%20product%20photography%20gentle%20fabric%20texture%20modern%20basics%20ecommerce%20aesthetic&width=400&height=400&seq=cat-underwear-01&orientation=squarish',
  },
  {
    key: 'jersey',
    label: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Sporty%20athletic%20jersey%20in%20vibrant%20color%20on%20clean%20minimal%20light%20background%20soft%20studio%20lighting%20editorial%20product%20photography%20detailed%20fabric%20texture%20modern%20sportswear%20aesthetic&width=400&height=400&seq=cat-jersey-01&orientation=squarish',
  },
  {
    key: 'accessories',
    label: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20watch%20and%20accessories%20arranged%20on%20clean%20light%20background%20soft%20natural%20lighting%20editorial%20product%20photography%20crisp%20metal%20detail%20premium%20ecommerce%20aesthetic&width=400&height=400&seq=cat-accessories-01&orientation=squarish',
  },
  {
    key: 'bags',
    label: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20backpack%20in%20neutral%20tone%20on%20clean%20minimal%20light%20background%20soft%20studio%20lighting%20editorial%20product%20photography%20crisp%20material%20detail%20contemporary%20fashion%20accessory%20aesthetic&width=400&height=400&seq=cat-bags-01&orientation=squarish',
  },
  {
    key: 'belts',
    label: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20coiled%20elegantly%20on%20clean%20light%20background%20soft%20natural%20lighting%20editorial%20product%20photography%20detailed%20leather%20texture%20modern%20fashion%20accessory%20aesthetic&width=400&height=400&seq=cat-belts-01&orientation=squarish',
  },
  {
    key: 'perfumes',
    label: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20soft%20light%20reflections%20on%20clean%20minimal%20background%20soft%20studio%20lighting%20editorial%20product%20photography%20luxury%20fragrance%20ecommerce%20aesthetic&width=400&height=400&seq=cat-perfumes-01&orientation=squarish',
  },
  {
    key: 'other',
    label: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20small%20fashion%20accessories%20and%20everyday%20items%20neatly%20arranged%20on%20clean%20light%20background%20minimal%20studio%20styling%20soft%20natural%20light%20editorial%20product%20photography%20modern%20ecommerce%20aesthetic&width=400&height=400&seq=cat-other-01&orientation=squarish',
  },
];